import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {AudienceIcon} from 'shells/icon/svg/audience-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ExploreIcon} from 'shells/icon/svg/explore-icon';
// @ts-expect-error - imported from .js/.jsx file
import {OutreachIcon} from 'shells/icon/svg/outreach-icon';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {SingleSelectCards} from 'shells/single-select-cards/single-select-cards';

export const GET_STARTED_MESSAGE_KEY = 'message';
export const GET_STARTED_AUDIENCE_KEY = 'audience';
export const GET_STARTED_EXPLORE_KEY = 'explore';

type Props = {
    selectedCard: string;
    onSelectCard: (arg1: string) => void;
};

export function GetStarted(props: Props) {
    // Managing local state because these updates don't propagate back
    // to this component
    const [selectedCard, setSelectedCard] = React.useState<string>(props.selectedCard);

    return (
        <OnboardingBody title={<span>Get started by…</span>}>
            <div style={{marginTop: '16px'}}>
                <SingleSelectCards
                    cards={[
                        {
                            id: GET_STARTED_MESSAGE_KEY,
                            subtitle: 'Drafting your first message',
                            // @ts-expect-error
                            icon: (
                                <OutreachIcon wrapWithDiv={false} size={18} fill={colors.greyDk} />
                            ),
                        },
                        {
                            id: GET_STARTED_AUDIENCE_KEY,
                            subtitle: 'Creating your first audience',
                            // @ts-expect-error
                            icon: (
                                <AudienceIcon wrapWithDiv={false} size={18} fill={colors.greyDk} />
                            ),
                        },
                        {
                            id: GET_STARTED_EXPLORE_KEY,
                            subtitle: 'Exploring on your own',
                            // @ts-expect-error
                            icon: (
                                <ExploreIcon wrapWithDiv={false} size={18} fill={colors.greyDk} />
                            ),
                        },
                    ]}
                    selectedId={selectedCard}
                    onSelect={(cardId) => {
                        setSelectedCard(cardId);
                        props.onSelectCard(cardId);
                    }}
                />
            </div>
        </OnboardingBody>
    );
}
